<template>
    <section>
        <v-skeleton-loader
                v-if="!ticket"
                type="card-heading,list-item-three-line,actions"
        ></v-skeleton-loader>

        <div
            v-else
            class="container container--fluid">
            <v-card :loading="loading">
                <v-card-title class="headline">
                    {{ticket.subject}}
                    <v-chip
                            small
                            class="ma-2"
                            :color="getStatusColor(ticket)"
                            text-color="white"
                    >
                        {{$t("ticket_status")[ticket.status]}}
                    </v-chip>
                    <v-spacer></v-spacer>
                    <v-btn
                            icon

                            @click="sync()"
                    >
                        <v-icon right dark>mdi-reload</v-icon>
                    </v-btn>
                    <v-chip
                            small
                            class="ma-2"
                    >
                        {{$t('ticket_number_text',{ ticket_number: ticket.ticket_number})}}
                    </v-chip>
                </v-card-title>
                <v-card-subtitle>
                    <v-chip>
                        {{ user.full_name }} {{ user.mobile }}
                    </v-chip>
                    {{$t('created_at')}} {{ getJalaliDate(ticket.created_at * 1000) }}</v-card-subtitle>
                <v-card-text v-text="ticket.description"></v-card-text>
                <v-card-actions>
                    <v-skeleton-loader
                            v-if="fetchingUsers"
                            type="text"
                            class="mt-2"
                    ></v-skeleton-loader>

                    <v-chip v-else>
                        پیگیری کننده :
                        <span v-if="ticket.assigned_user_id">
                            {{ assignedUser.full_name }} {{ assignedUser.mobile }}
                        </span>
                        <span v-else>
                            فاقد پیگیری کننده
                        </span>
                    </v-chip>
                    <v-spacer></v-spacer>
                    <v-tooltip top v-if="userCan('fax_numbers')">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    icon
                                    link
                                    :to="{name : 'FaxNumbers', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : ticket.user_id}]}}"
                                    class="no-decoration"
                            >
                                <v-icon v-bind="attrs"
                                        v-on="on"
                                >mdi-pound</v-icon>
                            </v-btn>

                        </template>
                        <span>{{$t('fax_numbers')}}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="true || userCan('logs_list')">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    icon
                                    link
                                    :to="{name : 'SubscriptionList', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : ticket.user_id}]}}"
                                    class="no-decoration"
                            >
                                <v-icon v-bind="attrs"
                                        v-on="on"
                                >mdi-package-variant</v-icon>
                            </v-btn>

                        </template>
                        <span>{{$t('subscriptions')}}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="true || userCan('faxes_list')">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    icon
                                    link
                                    :to="{name : 'FaxesList', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : ticket.user_id}]}}"
                                    class="no-decoration"
                            >
                                <v-icon v-bind="attrs"
                                        v-on="on"
                                >mdi-inbox-arrow-up</v-icon>
                            </v-btn>

                        </template>
                        <span>{{$t('sent_faxes_list')}}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="true || userCan('faxes_list')">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    icon
                                    link
                                    :to="{name : 'Inbox', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : ticket.user_id}]}}"
                                    class="no-decoration"
                            >
                                <v-icon v-bind="attrs"
                                        v-on="on"
                                >mdi-inbox-arrow-down</v-icon>
                            </v-btn>

                        </template>
                        <span>{{$t('fax_inbox')}}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="userCan('receipts')">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{name : 'Receipts', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : item.id}]}}"
                                        class="no-decoration"
                                >
                                    <v-icon v-bind="attrs"
                                            v-on="on"
                                    >mdi-account-cash</v-icon>
                                </router-link>
                            </template>
                            <span>{{$t('receipts')}}</span>
                        </v-tooltip>
                    <v-tooltip top v-if="true || userCan('logs_list')">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    icon
                                    link
                                    :to="{name : 'Logs', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : ticket.user_id}]}}"
                                    class="no-decoration"
                            >
                                <v-icon v-bind="attrs"
                                        v-on="on"
                                >mdi-math-log</v-icon>
                            </v-btn>

                        </template>
                        <span>{{$t('logs')}}</span>
                    </v-tooltip>
                </v-card-actions>
            </v-card>

            <v-card-title class="headline">
                پاسخ های تیکت
                <v-spacer></v-spacer>
                <v-btn
                        small
                        color="primary"
                        class="white--text"
                        @click="showForm()"
                        v-if="1"
                        text
                        :disabled="ticket.status == 'pending' || !!loading"
                >
                    {{$t('create_ticket_activity')}}
                    <v-icon right dark>mdi-plus</v-icon>
                </v-btn>
                <v-btn
                        small
                        color="primary"
                        class="white--text"
                        @click="ongoingTicket"
                        :disabled="ticket.status === 'ongoing' || !!loading"
                >
                    {{$t('ongoing_ticket')}}
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <div v-for="(ticketActivity, index) in ticket.activities" :key="index">
                <v-spacer class="mb-5 mx-auto"></v-spacer>
                <TicketActivity :ticketActivity="ticketActivity"></TicketActivity>
            </div>

            <v-alert
                    v-if="ticket.activities.length <= 0"
                    border="top"
                    color="red lighten-2"
                    dark
            >
                هیچ پاسخی هنوز برای این تیکت ثبت نشده است
            </v-alert>

            <TicketActivityForm
                    v-if="item"
                    :item="item"
                    :ticket="ticket"
                    @close="item = null"
                    @submit="sync"
            ></TicketActivityForm>
        </div>
    </section>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import Service from "../services/TicketService";
    import TicketActivity from "../components/TicketActivity";
    import TicketActivityForm from "../components/TicketActivityForm";

    export default {
        components : {
            TicketActivity,
            TicketActivityForm
        },
        mounted() {
            this.sync();
        },

        data() {
            return {
                item : null,
                loading : false,
                ticket : null,
                user : null,
                assignedUser : null,
            }
        },
        computed: {
            ...mapState({
                users: state => state.users.users,
            }),
            ...mapGetters({
                fetchingUsers: 'users/fetching',
            })
        },
        methods: {
            ...mapActions('users', ['fetchUsers']),

            getStatusColor(ticket){
                let color = null;
                switch (ticket.status){
                    case 'pending' :
                        color = null;
                        break;
                    case 'ongoing' :
                        color = 'warning';
                        break;
                    case 'answered' :
                        color = 'info';
                        break;
                    case 'closed' :
                        color = 'success';
                        break;
                }
                return color;
            },
            async sync() {
                this.loading = true;
                try {
                    let {data} = await Service.details(this.$route.params.ticketNumber);
                    this.ticket = data.value.ticket_details;
                    this.user = data.value.user;
                    this.assignedUser = data.value.assigned_user;
                    
                } finally {
                    this.loading = false;
                }
            },
            async ongoingTicket() {
                this.loading = true;
                try {
                    await Service.ongoingTicket(this.$route.params.ticketNumber);
                    this.sync()
                } finally {
                    this.loading = false;
                }
            },
            showForm(item) {
                item = item || Service.getDefaultTicketActivity();
                this.item = item;
            }

        }
    }
</script>